// @flow
import React from 'react';
import { useController } from 'react-hook-form';
import { DatePicker as CLDatePicker } from '@fortress-technology-solutions/fortress-component-library/Organisms';
import { Stack } from '@fortress-technology-solutions/fortress-component-library/Atoms';
import { formatDateDB } from '@fortress-technology-solutions/fortress-component-library/utils';

/**
 * React Hook Form wrapper around the Component Library Organisms DatePicker.
 * Unlike Forms/DatePicker (react-datetime), this supports `shouldDisableDate`
 * for per-day disabling — needed by the unit-transfer Transfer Date field.
 *
 * Props forwarded to CLDatePicker: label, shouldDisableDate, minDate, etc.
 * RHF control props: name, control, rules.
 */
function DatePickerCL(props: Object) {
  const {
    field,
    fieldState: { error },
  } = useController(props);

  return (
    <Stack direction="column">
      <CLDatePicker
        {...props}
        value={field.value}
        onChange={(date) => {
          // Normalize to YYYY-MM-DD string (column is DATEONLY)
          field.onChange(date ? formatDateDB(date) : date);
        }}
        onBlur={field.onBlur}
        inputRef={field.ref}
        error={!!error}
        // A validation error always wins; otherwise show whatever helper text the caller passed.
        helperText={error?.message ?? props.helperText}
      />
    </Stack>
  );
}

export default DatePickerCL;
